import React, { useContext, useEffect, useState } from "react";
import "./Shop_By_Brands.css";
import Common_Heading_Holder from "../../Common-Component/common_heading_holder/Common_Heading_Holder";
import { Swiper, SwiperSlide } from "swiper/react";
import { Context } from "../../../utils/context";
import { getData } from "../../../utils/api";
import { useNavigate } from "react-router-dom";

const Shop_By_Brands = ({ userId }) => {
  const { IMG_URL, shimmerLoader, setShimmerLoader } = useContext(Context);

  const [brand, setBrand] = useState([]);

  const getBrand = async () => {
    if (!userId) return;
    setShimmerLoader(true);
    const res = await getData(`/shop/brand?user_id=${userId}`);
    if (res?.success) {
      setBrand(res.data);
    }
    setShimmerLoader(false);
  };

  useEffect(() => {
    getBrand();
  }, [userId]);

  const data = [];

  const navigate = useNavigate();
  const nevigateBrand = async (id) => {
    navigate(`/shop-brand?user_id=${userId}&brand_id=${id}`);
  };

  return (
    <section className="Shop_By_Brands">
      <Common_Heading_Holder
        headingText={"Shop by Brands"}
        viewShowAllButton={true}
        goto={`/shop-brand?user_id=${userId}`}
      />

      <div className="all_brands_div">
        <div className="brand_swiper_div">
          <Swiper
            spaceBetween={15}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            //   modules={[Pagination]}
            autoplay={{ delay: 300 }}
            className="common_swiper"
            breakpoints={{
              0: {
                slidesPerView: 2.5,
                spaceBetween: 20,
              },
              420: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              490: {
                slidesPerView: 3.5,
                spaceBetween: 20,
              },
              576: {
                slidesPerView: 3.5,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
              992: {
                slidesPerView: 6.5,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 8,
                spaceBetween: 20,
              },
              1400: {
                slidesPerView: 9,
                spaceBetween: 20,
              },
            }}
          >
            {brand?.map((product) => {
              return (
                <SwiperSlide>
                  <div
                    className="brand_div"
                    onClick={() => nevigateBrand(product?.brand?.id)}
                  >
                    <div className="img_div">
                      <img
                        src={IMG_URL + product?.brand?.image}
                        className="brand_img"
                      />
                    </div>
                    <div className="green_div">
                      <p className="prod_name">{product?.brand?.name}</p>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Shop_By_Brands;
